import React, { PropsWithChildren } from "react";

export default function DialogBody({ children }: PropsWithChildren) {
  return (
    <div className="modal-body">
      {children}
    </div>
  );
}
